import NotAvailable from '../../components/fallback/NotAvailable'

const Communities: React.FC = () => {
  return <NotAvailable title={'Communities'} />
}

export default Communities
